module.exports = __webpack_public_path__ + "static/media/miah.833b78bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/miah.jpg
// module id = 1757
// module chunks = 147